import { createInertiaApp, router } from '@inertiajs/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { createQueryClient } from '../lib/queryClient'
import { csrfToken, syncCsrfToken } from '../lib/csrf'
import { browserTimeZone } from '../lib/timeZone'
import TaskOverlayProvider from '../components/TaskOverlayProvider'
import { initializeSentry } from '../lib/sentry'
import { reloadOnStaleBuild } from '../lib/staleBuild'

const sentryRootOptions = initializeSentry()
const queryClient = createQueryClient()

if (typeof document !== 'undefined') {
  reloadOnStaleBuild(window)
  router.on('success', (event) => syncCsrfToken(event.detail.page.props.csrf_token))
}

createInertiaApp({
  pages: '../pages',

  setup: ({ el, App, props }) => {
    syncCsrfToken(props.initialPage.props.csrf_token)
    const app = (
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <TaskOverlayProvider>
            <App {...props} />
          </TaskOverlayProvider>
        </QueryClientProvider>
      </StrictMode>
    )
    if (!el) return app
    if (el.hasAttribute('data-server-rendered')) hydrateRoot(el, app, sentryRootOptions)
    else createRoot(el, sentryRootOptions).render(app)
  },

  defaults: {
    form: { forceIndicesArrayFormatInFormData: false, withAllErrors: true },
    visitOptions: (_href, options) => {
      const token = csrfToken()
      const zone = browserTimeZone()
      return {
        queryStringArrayFormat: 'brackets',
        headers: { ...(options.headers || {}), ...(token ? { 'X-CSRF-Token': token } : {}), ...(zone ? { 'X-Time-Zone': zone } : {}) },
      }
    },
  },
}).catch((error) => {
  if (document.getElementById('app')) throw error
  console.error('Missing root element: inertia.tsx loaded on a non-Inertia page.')
})
